module.exports = __webpack_public_path__ + "6eb62d8699a751c172700174b34008ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/suppliers/bid_title.png
// module id = 693
// module chunks = 54 55 56 79 80 88